<template>
  <div v-if="jobExperience.position">
    <div
      class="block-header py-1 job-experience-header"
      :class="{ 'alternate-row-bg-gray': loopKey % 2 == 1, hiddenjobExperienceString: true }"
    >
      <div class="row w-100">
        <div class="col-4">
          <div
            v-if="currentRouteName !== backendExpertIndex && currentRouteName !== backendExpertView"
            class="custom-control custom-checkbox custom-control-lg mb-1"
            :class="customControlType"
          >
            <input
              :id="`jobExperienceCheckbox${jobExperience.id}`"
              v-model="myCheck"
              type="checkbox"
              class="custom-control-input job-experience-checkbox"
              name="jobExperienceIds[]"
              :value="true"
              :disabled="checkBoxDisabled"
            >
            <label
              class="custom-control-label job-experience-position"
              :for="`jobExperienceCheckbox${jobExperience.id}`"
            >
              {{ jobExperience.position }}
            </label>

            <span
              v-if="currentRouteName != 'backend.add.expert' && routes['backend_assignment_job_experience_featured_view']"
              :id="`jobExperienceFeature${jobExperience.id}`"
              class="btn btn-sm ms-1 job-experience-feature-btn"
              :class="featuredClass"
              @click.stop.prevent="patchAssignmentJobExperience"
            >
              {{ featuredText }}
            </span>
          </div>
          <span
            v-else
            class="job-experience-position"
          >
            {{ jobExperience.position }}
          </span>
        </div>
        <div class="col-4 job-experience-company-name">
          {{ jobExperience.company_name.company_name }}
        </div>
        <div class="col-4 job-experience-dates">
          {{ jobExperience.period_string }}
        </div>
      </div>
    </div>
    <div
      v-show="toggleExperienceContent"
      class="block-content row pt-0 job-experience-content"
      :class="{ 'alternate-row-bg-gray': loopKey % 2 === 1, hiddenjobExperienceString: true }"
    >
      <div class="col-sm-12">
        <div
          v-if="jobExperience.experience_details"
          class="row mb-2 pb-2"
        >
          <div class="col-sm-12">
            <label>Experience Details</label>
            <div v-html="jobExperience.experience_details" />
          </div>
        </div>

        <dl class="row">
          <dt
            v-if="jobExperience.job_scope"
            class="col-sm-3"
          >
            Job Scope
          </dt>
          <dd
            v-if="jobExperience.job_scope"
            class="col-sm-9"
            v-html="jobExperience.job_scope"
          />

          <dt
            v-if="jobExperience.commercials"
            class="col-sm-3"
          >
            Commercials
          </dt>
          <dd
            v-if="jobExperience.commercials"
            class="col-sm-9"
            v-html="jobExperience.commercials"
          />

          <dt
            v-if="jobExperience.people_management"
            class="col-sm-3"
          >
            People Management:
          </dt>
          <dd
            v-if="jobExperience.people_management"
            class="col-sm-9"
            v-html="jobExperience.people_management"
          />
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "../../../../mixins/mixin";
export default {
  mixins: [mixin],
  props: {
    experience: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    expert: {
      type: Object,
      required: true,
    },
    loopKey: {
      type: Number,
      required: false,
      default() {
        return 0;
      },
    },
    currentRouteName: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    checkBoxDisabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    toggleExperienceContent: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    routes: {
      type: [Object, Array],
      required: false,
      default() {
        return {};
      },
    },
    relevantAssignment: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    attachedJobExperienceIds: {
      type: [Object, Array],
      required: false,
      default() {
        return [];
      },
    },
    jobExperienceChecked: {
      type: [Object, Array],
      required: false,
      default() {
        return [];
      },
    },
    mainCheck: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      assignmentJobExperienceString: "",
      hiddenjobExperienceString: "",
      featured: false,
      featuredClass: "btn-outline-secondary",
      featuredText: "Feature",
      customControlType: "",
      assignmentJobExperienceId: null,
      myCheck: false,
      legacyConfig: {
        headers: {
          "Content-Type": "application/vnd.api+json",
        },
      },
    };
  },
  computed: {
    jobExperience() {
      return this.experience;
    },
    endDateString() {
      if (!this.jobExperience.end_date) {
        return "Present";
      }
      return this.formatDate(this.jobExperience.end_date);
    },
    mainCheckComputed() {
      return this.mainCheck;
    },
    expertName() {
      const str = `${this.user.first_name} ${this.user.last_name}`;
      return str.trim();
    },
    myCheckComputed() {
      return this.myCheck;
    },
  },
  watch: {
    mainCheckComputed(nv, ov) {
        this.myCheck = this.mainCheck
      //if (this.currentRouteName != "backend.add.expert") this.myCheck = this.mainCheck;
    },
    myCheckComputed(nv, ov) {
      if (this.myCheck) this.$emit("toJobsSelected", this.experience.id);
      else this.$emit("removeJobsSelected", this.experience.id);
    },
  },
  mounted() {
    if (this.currentRouteName != "backend.add.expert") {
      setTimeout(() => {
        const id = `jobExperienceCheckbox${this.jobExperience.id}`;
        const element = document.getElementById(id);
        if (element) {
          element.checked = false;
        }
      }, 100);
    }
    this.init();
  },
  methods: {
    init() {
      let assignmentJobExperience = null;
      if (this.currentRouteName === "backend.project.details" || this.currentRouteName === "backend.project.details.showAll") {
        if (this.attachedJobExperienceIds.includes(this.jobExperience.id)) {
          this.hiddenjobExperienceString = "d-none---";
        } else {
          this.assignmentJobExperiences = [...this.relevantAssignment.assignment_job_experiences];

          this.assignmentJobExperiences.forEach(a => {
            if (a.job_experience_id == this.jobExperience.id) {
              assignmentJobExperience = a;
              this.assignmentJobExperienceId = assignmentJobExperience.id;
              this.assignmentJobExperienceString = `assignmentJobExperienceId=${this.assignmentJobExperienceId}`;
            }
          });
        }
      }
      //console.log("assignmentJobExperience------");
      //console.log(assignmentJobExperience);
      if (this.relevantAssignment && assignmentJobExperience) {
        if (assignmentJobExperience.featured == true) {
          this.featured = true;
          this.featuredClass = "btn-success";
          this.featuredText = "Featured";
        }
      }
      this.myCheck = this.jobExperienceChecked.includes(Number(this.jobExperience.id));
    },
    async patchAssignmentJobExperience() {
      if (confirm(`Are you sure you want to change the featured job experience for ${this.expertName}?`) === false) {
        return;
      }
      let shouldFeature = true;
      if (this.featured == true) {
        shouldFeature = false;
      }

      const payload = {
        data: {
          type: "assignmentJobExperiences",
          id: String(this.assignmentJobExperienceId),
          attributes: {
            featured: shouldFeature,
          },
        },
      };
      try {
        const response = axios.patch(`/api/v2/assignmentJobExperiences/${this.assignmentJobExperienceId}`, payload, this.legacyConfig);
        this.featured = !this.featured;
        if (this.featured) {
          this.featuredClass = "btn-success";
          this.featuredText = "Featured";
        } else {
          this.featuredClass = "btn-outline-secondary";
          this.featuredText = "Feature";
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
